import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';


const material1 = new THREE.MeshStandardMaterial();
const material2 = new THREE.MeshStandardMaterial({
  vertexColors: true,
  transparent: true,
  opacity: 0.5
});
const material3 = new THREE.MeshBasicMaterial({ vertexColors: true , side: THREE.DoubleSide });
const material4 = new THREE.MeshBasicMaterial({ color: 0xf5f5f5, wireframe:true, side: THREE.DoubleSide });
const material5 = new THREE.MeshPhongMaterial({ color: 0xf5f5f5, side: THREE.DoubleSide })

//type: NORMAL / TRANSPARENT
export function GetMaterial(type) {
  switch(type){
    case 'NORMAL':
      return material1;
    case 'TRANSPARENT':
      return material2;
    case 'VERTEX':
      return material3;
    case 'WIREFRAME':
      return material4;
    case 'PHONG':
      return material5;
  }
}


function loadGeometry(url) {
  return new Promise(resolve => {
    var loader = new STLLoader();
    loader.load(url, resolve);
  });
}
export function LoadSTL(url, type) {
  const promises = [
    loadGeometry(url)
  ];
  const material = GetMaterial(type);
  
  return Promise.all(promises).then(result => {
    console.log("LoadSTL", url);
    return new THREE.Mesh(result[0], material);
  });
}

export function readSTL(file) {
  var loader = new STLLoader();
  var geometry = loader.parse(file);
  var mesh = new THREE.Mesh(geometry, material1);
  return mesh;
}

export function readPLY(file) {
  var loader = new PLYLoader();
  var geometry = loader.parse(file);
  var material = GetMaterial('VERTEX');
  var mesh = new THREE.Mesh(geometry, material);
  return mesh;
}

export function readOBJ(file) {
  var loader = new OBJLoader();
  var geometry = loader.parse(file);
  var material = GetMaterial('VERTEX');
  var mesh = new THREE.Mesh(geometry, material);
  return mesh;
}

export const readPhoto = (file, direction, callback) => {
  var image = new Image();
  image.onload = function () {
    var texture = new THREE.Texture(image);
    texture.needsUpdate = true;

    const geometry = new THREE.PlaneGeometry(1, 1);
    const material = new THREE.MeshPhongMaterial({ map:texture });
    const plane = new THREE.Mesh( geometry, material );

    console.log("plane", plane);

    const w = 200;
    const h = this.height/this.width*w;

    if(direction == "Front"){
      plane.scale.set(-w, h, 1);
      plane.rotation.x = Math.PI / 2;
    }else if(direction == "Side"){
      plane.scale.set(w, h, 1);
      plane.rotation.y = Math.PI / 2;
      plane.rotation.z = Math.PI / 2;
    }
    callback(plane);
  };
  image.src = file;
}

export const loadPLYFile = (file, callback) => {  
  var reader = new FileReader();
  reader.onload = function() {
    var mesh = readPLY(reader.result);
    mesh.geometry.computeBoundingBox();
    console.log("boundingBox", mesh.geometry.boundingBox);
    callback(mesh);
  };
  reader.readAsArrayBuffer( file );
}

export const loadSTLFile = (file, callback) => {  
  var reader = new FileReader();
  reader.onload = function() {
    var mesh = readSTL(reader.result);
    callback(mesh);
  };
  reader.readAsBinaryString( file );
}

export const loadOBJFile = (file, callback) => {  
  var reader = new FileReader();
  reader.onload = function() {
    console.log("reader", reader);
    var mesh = readOBJ(reader.result);
    console.log("mesh", mesh);
    callback(mesh);
  };
  reader.readAsText( file );
}

export const loadPhotoFile = (file, direction, callback) => {
  //console.log("loadPhotoFile", file);
  
  var reader = new FileReader();
  reader.onload = function() {
    readPhoto( reader.result, direction, (plane) => {
      callback(plane);
    });
  };
  reader.readAsDataURL( file );
}
